import { Outlet, useNavigate } from 'react-router-dom';
import { usePageTitle } from '@/shared/lib/use-page-title';
import { Footer } from './footer';
import './nav-shell.css';

export function NavShell() {
  const navigate = useNavigate();
  const { title, contentRef } = usePageTitle();

  return (
    <div className="nav-shell">
      <div className="nav-shell__bar">
        <button type="button" className="nav-shell__back" aria-label="뒤로가기" onClick={() => navigate(-1)}>
          <svg aria-hidden="true" viewBox="0 0 20 20" width="20" height="20" fill="none">
            <path
              d="M12.5 4.5 7 10l5.5 5.5"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="nav-shell__title">{title}</h1>
      </div>
      <div className="nav-shell__content" ref={contentRef} tabIndex={-1}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
